import * as React from "react";
import {
  Box,
  Tab,
  ListItemIcon,
  Tooltip,
  IconButton,
  // Divider,
  Menu,
  MenuItem,
  // Avatar,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Organizations from "views/tagadmin/Organisations";
import OrganizationUser from "views/tagadmin//organizationUser";
import OrganizationExport from "views/tagadmin//organizationExport";
import Logo from "assets/images/logo.svg";
// import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import AvatarComponent from "components/Avatar";

export default function CustomAppBar() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [value, setValue] = React.useState("1");
  const navTabSx = {
    fontSize: "1.5rem",
    fontFamily: '"aktiv-grotesk", sans-serif',
    lineHeight: "30px",
    marginBottom: 0,
    marginRight: "20px",
    padding: 0,
    textTransform: "capitalize",
    color: "#005298",
    minHeight: "unset",
    "&.Mui-selected": {
      color: "#005298",
      borderBottom: "2px solid #005298",
    },
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logoutAccount = () => {
    localStorage.removeItem("refresh");
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <>
      {/* <Header /> */}
      <Box className="b-nav-container">
        <TabContext value={value}>
          <Box container className="b-nav-container__box">
            <Box>
              <img className="b-nav-container__logo-img" alt="" src={Logo} />
            </Box>
            <Box className="b-nav-container__tablist-container">
              <TabList
                onChange={handleChange}
                className="b-nav-container__tablist"
                aria-label="lab API tabs example"
                TabIndicatorProps={{
                  style: { display: "none", height: 0 },
                }}
                sx={{
                  "& .MuiTabs-indicator": {
                    display: "none !important",
                    height: 0,
                  },
                }}
              >
                <Tab
                  className="b-nav-container__nav-tab "
                  label="Organizations"
                  value="1"
                  sx={navTabSx}
                />
                <Tab
                  className="b-nav-container__nav-tab "
                  label="Users"
                  value="2"
                  sx={navTabSx}
                />
                <Tab
                  className="b-nav-container__nav-tab "
                  label="Export"
                  value="3"
                  sx={navTabSx}
                />
              </TabList>
            </Box>
            <Tooltip title="Account Settings">
              <IconButton
                onClick={handleClick}
                size="small"
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <AvatarComponent firstname="A" />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              {/* <MenuItem>
                <Avatar /> Profile
              </MenuItem>
              <MenuItem>
                <Avatar /> My Account
              </MenuItem>
              <Divider />
              <MenuItem>
                <ListItemIcon>
                  <Settings fontSize="small" />
                </ListItemIcon>
                Settings
              </MenuItem> */}
              <MenuItem onClick={logoutAccount}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </Box>
          <TabPanel value="1">
            <Organizations />
          </TabPanel>
          <TabPanel value="2">
            <OrganizationUser />
          </TabPanel>
          <TabPanel value="3">
            <OrganizationExport />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
}
